module.exports = __webpack_public_path__ + "img/Doc18a_Maximilian-Lee.2dc9b257.jpg";